import { AxiosRequestConfig } from "axios";
import { CommonAxiosService } from "../common-axios-service";
import { ClassRequestModel, CommonResponse } from "@boi/shared-models";

export class DashBoardService extends CommonAxiosService {
  private getURLwithMainEndPoint(childUrl: string) {
    return "/dashboard/" + childUrl;
  }

  async getLanguageDistribution(
    req: ClassRequestModel,
    config?: AxiosRequestConfig
  ): Promise<CommonResponse> {
    return await this.axiosPostCall(
      this.getURLwithMainEndPoint("getLanguageDistribution"),
      req,
      config
    );
  }

  async getDifficultyBreakdown(
    config?: AxiosRequestConfig
  ): Promise<CommonResponse> {
    return await this.axiosPostCall(
      this.getURLwithMainEndPoint("difficulty-breakdown"),
      config
    );
  }

  async getSubjectDifficultySplit(
    req: ClassRequestModel,
    config?: AxiosRequestConfig
  ): Promise<CommonResponse> {
    return await this.axiosPostCall(
      this.getURLwithMainEndPoint("subject-difficulty-split"),
      req,
      config
    );
  }

  async getSubjectsWiseDistribution(
    req: ClassRequestModel,
    config?: AxiosRequestConfig
  ): Promise<CommonResponse> {
    console.log("ss", req.classId);
    return await this.axiosPostCall(
      this.getURLwithMainEndPoint("subjects-wise-distribution"),
      req,
      config
    );
  }

  async getTopFiveByQuestionCount(
    req: ClassRequestModel,
    config?: AxiosRequestConfig
  ): Promise<CommonResponse> {
    return await this.axiosPostCall(
      this.getURLwithMainEndPoint("top-five-by-question-count"),
      req,
      config
    );
  }

  async getClassComparison(
    config?: AxiosRequestConfig
  ): Promise<CommonResponse> {
    return await this.axiosPostCall(
      this.getURLwithMainEndPoint("class-comparison"),
      config
    );
  }

  async getMonthlyAdditions(
    config?: AxiosRequestConfig
  ): Promise<CommonResponse> {
    return await this.axiosPostCall(
      this.getURLwithMainEndPoint("monthly-additions"),
      config
    );
  }

  async getPaperStats(config?: AxiosRequestConfig): Promise<CommonResponse> {
    return await this.axiosPostCall(
      this.getURLwithMainEndPoint("paper-status"),
      config
    );
  }

  async getPaperTrend(config?: AxiosRequestConfig): Promise<CommonResponse> {
    return await this.axiosPostCall(
      this.getURLwithMainEndPoint("paper-trend"),
      config
    );
  }

  async getOverviewStats(config?: AxiosRequestConfig): Promise<CommonResponse> {
    return await this.axiosPostCall(
      this.getURLwithMainEndPoint("overview-stats"),
      config
    );
  }

  async getAbilityDistribution(
    req: ClassRequestModel,
    config?: AxiosRequestConfig
  ): Promise<CommonResponse> {
    return await this.axiosPostCall(
      this.getURLwithMainEndPoint("ability-distribution"),
      req,
      config
    );
  }

  async getSubjectsByClass(
    req: ClassRequestModel,
    config?: AxiosRequestConfig
  ): Promise<CommonResponse> {
    return await this.axiosPostCall(
      "/ai_generated_qp/getSubjectsByClass",
      req,
      config
    );
  }

  async getOverallDifficultyMix(
    req: ClassRequestModel,
    config?: AxiosRequestConfig
  ): Promise<CommonResponse> {
    return await this.axiosPostCall(
      this.getURLwithMainEndPoint("overall-difficulty-mix"),
      req,
      config
    );
  }

  async getSubAbilityDistribution(
    req: ClassRequestModel,
    config?: AxiosRequestConfig
  ): Promise<CommonResponse> {
    return await this.axiosPostCall(
      this.getURLwithMainEndPoint("sub-ability-distribution"),
      req,
      config
    );
  }

  async getBlueprintSummary(
    config?: AxiosRequestConfig
  ): Promise<CommonResponse> {
    return await this.axiosPostCall(
      this.getURLwithMainEndPoint("blueprint-summary"),
      config
    );
  }

  async getRecentBlueprints(
    config?: AxiosRequestConfig
  ): Promise<CommonResponse> {
    return await this.axiosPostCall(
      this.getURLwithMainEndPoint("recent-blueprints"),
      config
    );
  }

  async getRecentQuestionPapers(
    config?: AxiosRequestConfig
  ): Promise<CommonResponse> {
    return await this.axiosPostCall(
      this.getURLwithMainEndPoint("recent-papers"),
      config
    );
  }

  async getQuestionsBySubject(
    req: ClassRequestModel,
    config?: AxiosRequestConfig
  ): Promise<CommonResponse> {
    return await this.axiosPostCall(
      this.getURLwithMainEndPoint("questions-by-subject"),
      req,
      config
    );
  }
}
